import { Container, Graphics } from "pixi.js";

/**
 * Destellos de bloom en pantalla. Solo render.
 *
 * Aqui vivia tambien un vignette: cuatro rectangulos negros de un 8% del lado
 * mayor, a 0,38-0,48 de opacidad, sobre los cuatro bordes. Con BORDE DURO, no
 * degradado.
 *
 * Se quito porque se veian como franjas. Mientras el campo no llegaba a los
 * bordes de la pantalla, esos rectangulos caian encima del estadio —que ya era
 * oscuro— y no se notaban. Al hacer que el cesped ocupe la ventana entera
 * pasaron a caer sobre hierba iluminada, y entonces se leen como dos bandas
 * arriba y abajo y otras dos en los lados: exactamente lo que se venia a
 * quitar. En un movil en horizontal (390 px de alto) las de arriba y abajo se
 * comian 134 px entre las dos.
 *
 * El bloom se queda: es un destello puntual en los goles, no un marco fijo.
 */
export interface ScreenFx {
  container: Container;
  layout(screenWidth: number, screenHeight: number): void;
  update(dt: number): void;
  /** Pulso de bloom (gol, tiro perfecto, etc.). */
  pulse(intensity: number, color: number): void;
}

interface Pulse {
  life: number;
  maxLife: number;
  intensity: number;
  color: number;
}

export function createScreenFx(): ScreenFx {
  const container = new Container();
  container.label = "screen-fx";

  const bloom = new Graphics();
  container.addChild(bloom);

  let screenW = 800;
  let screenH = 600;
  const pulses: Pulse[] = [];

  return {
    container,

    layout(screenWidth: number, screenHeight: number): void {
      screenW = screenWidth;
      screenH = screenHeight;
    },

    pulse(intensity: number, color: number): void {
      const clamped = Math.max(0, Math.min(1, intensity));
      if (clamped <= 0) return;
      pulses.push({
        life: 0.45 + clamped * 0.35,
        maxLife: 0.45 + clamped * 0.35,
        intensity: clamped,
        color,
      });
    },

    update(dt: number): void {
      bloom.clear();
      let active = false;

      for (let i = pulses.length - 1; i >= 0; i--) {
        const p = pulses[i]!;
        p.life -= dt;
        if (p.life <= 0) {
          pulses.splice(i, 1);
          continue;
        }
        active = true;
        const t = p.life / p.maxLife;
        const fade = t * t;
        const cx = screenW * 0.5;
        const cy = screenH * 0.46;
        const baseR = Math.min(screenW, screenH) * (0.22 + (1 - t) * 0.18);

        bloom.circle(cx, cy, baseR * 1.6).fill({ color: p.color, alpha: fade * p.intensity * 0.12 });
        bloom.circle(cx, cy, baseR).fill({ color: 0xffffff, alpha: fade * p.intensity * 0.08 });
        bloom.rect(0, 0, screenW, screenH).fill({ color: p.color, alpha: fade * p.intensity * 0.06 });
      }

      bloom.visible = active;
    },
  };
}
